/**
 * Interpretazione dei nomi prodotto che arrivano dal BE.
 *
 * Le etichette vengono ricavate dal nome (es. VIDEO-PLAYER-THREE-YEARS => "Player 3 anni",
 * NANOMID-COUPON-VIDEO-PLAYER-IOS-THREE-YEARS => "Coupon Player iOS 3 anni", VPN-TWELVE-MONTHS => "VPN Pass 12 mesi"),
 * così i nuovi prodotti vengono mostrati senza dover aggiornare una lista fissa.
 * I prodotti LIFETIME e TRIAL non fanno più parte delle statistiche e vengono scartati.
 */

const NUMBERS = { ONE: 1, TWO: 2, THREE: 3, SIX: 6, TEN: 10, TWELVE: 12, TWENTYFOUR: 24, THIRTYSIX: 36 };
const UNITS = { DAY: 'day', DAYS: 'day', MONTH: 'month', MONTHS: 'month', YEAR: 'year', YEARS: 'year' };

// colori fissi per durata (in mesi): il colore segue la durata in tutti i grafici
const DURATION_COLORS = { 1: '#2a78d6', 3: '#eb6834', 6: '#1baf7a', 12: '#eda100', 24: '#e87ba4', 36: '#008300' };
const EXTRA_COLORS = ['#4a3aa7', '#e34948'];

export const PRIMARY_COLOR = '#2a78d6';

export const isLegacyProduct = (code) => /LIFETIME|TRIAL/.test(String(code).toUpperCase());

function findDuration(tokens) {
    for (let i = 0; i < tokens.length - 1; i++) {
        if (NUMBERS[tokens[i]] && UNITS[tokens[i + 1]]) {
            const value = NUMBERS[tokens[i]];
            const unit = UNITS[tokens[i + 1]];
            const months = unit === 'year' ? value * 12 : unit === 'month' ? value : value / 30;
            return { value, unit, months };
        }
    }
    return null;
}

export function durationLabel(duration) {
    if (!duration) return '';
    const { value, unit } = duration;
    if (unit === 'year') return `${value} ${value === 1 ? 'anno' : 'anni'}`;
    if (unit === 'month') return `${value} ${value === 1 ? 'mese' : 'mesi'}`;
    return `${value} ${value === 1 ? 'giorno' : 'giorni'}`;
}

/**
 * Scompone il nome di un prodotto in famiglia, piattaforma e durata.
 */
export function parseProduct(code) {
    const upper = String(code || '').toUpperCase();
    const tokens = upper.split('-');

    let family = 'other';
    if (upper.includes('VIDEO-PLAYER')) family = 'player';
    else if (upper.startsWith('VPNBOX') || upper.includes('VPN-BOX')) family = 'vpnBox';
    else if (upper.startsWith('VPN') || upper.startsWith('PASS')) family = 'vpnPass';
    else if (upper === 'SHIPPING') family = 'shipping';

    return {
        code: upper,
        family,
        coupon: tokens.includes('COUPON'),
        hardware: tokens.includes('HW'),
        platform: tokens.includes('IOS') ? 'iOS' : tokens.includes('ANDROID') ? 'Android' : null,
        duration: findDuration(tokens)
    };
}

const titleCase = (code) => code.toLowerCase().split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export function productLabel(code) {
    const p = parseProduct(code);
    const duration = durationLabel(p.duration);

    switch (p.family) {
        case 'player':
            return [p.coupon ? 'Coupon' : null, 'Player', p.platform, duration].filter(Boolean).join(' ');
        case 'vpnPass':
            return ['VPN Pass', duration].filter(Boolean).join(' ');
        case 'vpnBox':
            return [p.hardware ? 'VPN Box HW' : 'VPN Box', duration].filter(Boolean).join(' ');
        case 'shipping':
            return 'Spedizione';
        default:
            return titleCase(p.code);
    }
}

export function durationColor(months, index = 0) {
    return DURATION_COLORS[months] || EXTRA_COLORS[index % EXTRA_COLORS.length];
}

const PROVIDERS = { Netopia_cc: 'Netopia', NanoMidPromo: 'Promo 100%', Manual: 'Manuale' };
export const providerLabel = (key) => PROVIDERS[key] || key;

const PLATFORMS = { 'sectv-tizen': 'Samsung', 'tv-webos': 'LG', android: 'Android', ios: 'iOS' };
export const platformLabel = (key) => PLATFORMS[key] || key;
